var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.715 20.6655C11.1497 22.2383 11.1497 24.7886 12.715 26.3614C14.2804 27.9341 16.8186 27.9341 18.3839 26.3614L12.715 20.6655Z",
    stroke: "#1D1F20",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2606 19.2143L19.8285 24.8087C20.2414 25.2235 20.2414 25.8961 19.8285 26.3109C19.4157 26.7257 18.7463 26.7257 18.3335 26.3109L12.7655 20.7158C12.3527 20.3011 12.3527 19.6285 12.7655 19.2137C13.1784 18.7989 13.8478 18.7989 14.2606 19.2137V19.2143Z",
    stroke: "#1D1F20",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4038 11.0428L27.9617 14.6176C29.1383 15.7998 29.0415 17.7445 27.7532 18.8029L20.1049 25.0868L13.9841 18.9369L20.2383 11.2523C21.2917 9.95784 23.2272 9.86063 24.4038 11.0428Z",
    stroke: "#1D1F20",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6943 13.299C21.398 12.4344 22.6911 12.3692 23.4777 13.159",
    stroke: "#1D1F20",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5338 25.5814C15.6312 25.4836 15.7892 25.4836 15.8866 25.5814C15.9839 25.6792 15.9839 25.838 15.8866 25.9358C15.7892 26.0336 15.6312 26.0336 15.5338 25.9358C15.4365 25.838 15.4365 25.6792 15.5338 25.5814Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6531 25.0659C13.7504 24.9681 13.9085 24.9681 14.0058 25.0659C14.1032 25.1637 14.1032 25.3225 14.0058 25.4203C13.9085 25.5181 13.7504 25.5181 13.6531 25.4203C13.5557 25.3225 13.5557 25.1637 13.6531 25.0659Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1393 23.175C13.2366 23.0772 13.3947 23.0772 13.492 23.175C13.5894 23.2728 13.5894 23.4316 13.492 23.5294C13.3947 23.6272 13.2366 23.6272 13.1393 23.5294C13.0419 23.4316 13.0419 23.2728 13.1393 23.175Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2879 27.6147C11.3852 27.5169 11.5432 27.5169 11.6406 27.6147C11.7379 27.7125 11.7379 27.8713 11.6406 27.9691C11.5432 28.067 11.3852 28.067 11.2879 27.9691C11.1905 27.8713 11.1905 27.7125 11.2879 27.6147Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8904 29.1105C12.9877 29.0127 13.1458 29.0127 13.2431 29.1105C13.3405 29.2083 13.3405 29.3671 13.2431 29.4649C13.1458 29.5627 12.9877 29.5627 12.8904 29.4649C12.793 29.3671 12.793 29.2083 12.8904 29.1105V29.1105Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4924 30.6062C14.5898 30.5084 14.7478 30.5084 14.8452 30.6062C14.9425 30.704 14.9425 30.8628 14.8452 30.9606C14.7478 31.0584 14.5898 31.0584 14.4924 30.9606C14.3951 30.8628 14.3951 30.704 14.4924 30.6062Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2879 30.6062C11.3852 30.5084 11.5432 30.5084 11.6406 30.6062C11.7379 30.704 11.7379 30.8628 11.6406 30.9606C11.5432 31.0584 11.3852 31.0584 11.2879 30.9606C11.1905 30.8628 11.1905 30.704 11.2879 30.6062Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8904 32.1008C12.9877 32.003 13.1458 32.003 13.2431 32.1008C13.3405 32.1986 13.3405 32.3574 13.2431 32.4552C13.1458 32.553 12.9877 32.553 12.8904 32.4552C12.793 32.3574 12.793 32.1986 12.8904 32.1008V32.1008Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5372 33.3559C11.6346 33.2581 11.7926 33.2581 11.89 33.3559C11.9873 33.4537 11.9873 33.6125 11.89 33.7103C11.7926 33.8081 11.6346 33.8081 11.5372 33.7103C11.4399 33.6125 11.4399 33.4537 11.5372 33.3559V33.3559Z",
    stroke: "#1D1F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalt);
export default __webpack_public_path__ + "static/media/salt.fb704c76c3de650ad741e5d9264ab50c.svg";
export { ForwardRef as ReactComponent };